import { FC } from 'react';
import { Box, Center, Flex, Spinner, Text } from '@chakra-ui/react';

import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import { useTranslation } from 'helpers/languages/translations';
import useSectoContainer from './SectoContainer';
import SectoEditModal from './SectoEditModal';
import SectoToolbar from './SectoToolbar';

const SectoViewer: FC<{ toolId: number }> = ({ toolId }) => {
    const props = useSectoContainer({ toolId });
    const translate = useTranslation();
    const { isLoading, tableInstance, selectedRetailer } = props;

    return (
        <Box mt="16px">
            {isLoading ? (
                <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                    <Spinner />
                </Center>
            ) : (
                <>
                    <SectoToolbar {...props} toolId={toolId} />
                    <SectoEditModal {...props} toolId={toolId} />
                    {selectedRetailer !== 0 ? (
                        <DITable {...tableInstance} isPagination />
                    ) : (
                        <Flex h={100} bg="white" align="center" justifyContent="center">
                            <Text fontSize="md">{translate(`secto.viewer.table.retailer`)}</Text>
                        </Flex>
                    )}
                    <TablePagination tableInstance={tableInstance} />
                </>
            )}
        </Box>
    );
};

export default SectoViewer;
